import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import Hero from '@/components/home/Hero';
import TrustBar from '@/components/home/TrustBar';
import ServicesGrid from '@/components/home/ServicesGrid';
import ContactSection from '@/components/home/ContactSection';

export default function HomePage() {
    return (
        <div className="bg-la-canvas text-la-text min-h-screen">
            <Navbar />
            <main>
                <Hero />
                <TrustBar />
                <ServicesGrid />
                <ContactSection />
            </main>
            <Footer />
        </div>
    );
}
